import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Router } from '@angular/router';
import {from, Observable, of} from 'rxjs';
import {switchMap} from 'rxjs/operators';
import {SessionService} from '../../core/services/session.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    constructor(private sessionService: SessionService, private router: Router) { }

    canActivate(): Observable<boolean> | boolean {
        return from(this.sessionService.getToken()).pipe(
            switchMap(res => {
                if (res === null || res === undefined) {
                    this.router.navigate(['/auth/login']);
                    return of(false);
                }
                if (res.length !== 0) {
                    return of(true);
                }
                else {
                    this.router.navigate(['/auth/login']);
                    return of(false);
                }
            }));
    }
}
